"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventUserFilter = void 0;
var EventUserFilter;
(function (EventUserFilter) {
    EventUserFilter["CURRENT"] = "CURRENT";
    EventUserFilter["ALL"] = "ALL";
})(EventUserFilter = exports.EventUserFilter || (exports.EventUserFilter = {}));
//# sourceMappingURL=eventUserFilter.js.map